<script>
	import Icon from "../../library/Icon.svelte";

	export let api;

	function handleRedo() {
		api?.getStores().state.redo();
	}

	$: state = api.getReactiveState();
	$: history = state.historyState;
	$: activeProject = state.activeProject;
	$: historyState = state.historyState;

	let canRedo;
	$: {
		const log = $history.redo?.filter(u => {
			if (typeof u === "object") {
				return (
					u.branchId === "$allBranches" ||
					u.branchId === $activeProject
				);
			}
			const batches = $historyState.batches[u][0];
			return (
				batches.branchId === "$allBranches" ||
				batches.branchId === $activeProject
			);
		});
		canRedo = log.length > 0;
	}

</script>

<div class="wx-todo_redo">
	<Icon on:click={handleRedo} name={'redo'} disabled={!canRedo} clickable />
</div>

<style>
	.wx-todo_redo {
		margin-right: 12px;
	}

</style>
